import { createSlice } from "@reduxjs/toolkit";

export const pageTitle = createSlice({
  name: "pageTitle",
  initialState: "",
  reducers: {
    change: (state, action) => action.payload,
  },
});

export const selectors = {
  get: (state) => state.pageTitle,
};
export const changePageTitle = pageTitle.actions.change;
